exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container .go[data-v-201c03de]{width:44.8px;width:2.8rem;height:12.8px;height:.8rem;bottom:6.4px;bottom:.4rem;left:70%}.container .guide-top-pic[data-v-201c03de]{height:98.56px;height:6.16rem;background-size:cover;background-position:50%}.container .session-second-wrap[data-v-201c03de]{background:#fff}.container .has-margin-bottom[data-v-201c03de]{margin-bottom:21.333px;margin-bottom:1.33333rem}@media screen and (min-width:1025px){[pc=\"1\"] .guide-top-pic[data-v-201c03de]{height:462px;background-size:100% 100%}[pc=\"1\"] .go[data-v-201c03de]{width:210px;height:60px;bottom:30px;left:60%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template/client/smsgz/assets","/static":"/data/efun/gw-template/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-201c03de","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/pages/guide.vue
// module id = VvkQ
// module chunks = 1